<template>
  <div class="create-product">
    <!-- 商品维护-->
    <div class="wran-msg">
      <div class="bold">提示：</div>
      <div>
        原易派客平台面向非石化企业销售的商品，已自动同步下方商品列表，但不包括通过石化框架协议上线未开外销的商品、
        以及部分化工类商品和存在错误信息的商品，如列表中未查到，请
        <span class="re-reeact" @click="reCreate">重新发布商品</span>
        。
      </div>
    </div>
    <div class="create-product-container">
      <div class="search-box">
        <el-form ref="query" :inline="true" :model="query" class="search-form">
          <el-form-item v-if="editFlag === 'third' || editFlag === 'fourth' || editFlag === 'fifth'" label="商品名称：">
            <el-input v-model.trim="query.skuName" placeholder="商品名称" @keyup.enter.native="handleSearch"></el-input>
          </el-form-item>
          <el-form-item
            v-if="editFlag === 'third' || editFlag === 'fourth' || editFlag === 'fifth'"
            label="商品编号："
            prop="isPic"
          >
            <el-input v-model.trim="query.skuCode" placeholder="商品编号" @keyup.enter.native="handleSearch"></el-input>
          </el-form-item>

          <el-form-item v-if="editFlag === 'first' || editFlag === 'second'" label="商品名称：" prop="skuName">
            <el-input v-model.trim="query.skuName" placeholder="商品名称" @keyup.enter.native="handleSearch"></el-input>
          </el-form-item>
          <el-form-item label="商品来源：" prop="skuName">
            <el-select v-model="query.systemSign" placeholder="请选择">
              <el-option
                v-for="item in systemSignList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="editFlag === 'first' || editFlag === 'second'" label="商品编号：" prop="isPic">
            <el-input v-model.trim="query.skuCode" placeholder="商品编号" @keyup.enter.native="handleSearch"></el-input>
          </el-form-item>

          <el-form-item v-if="editFlag === 'first'" label="进出口推送状态：" prop="pushStatus">
            <el-select v-model.trim="query.pushStatus" placeholder="进出口推送状态">
              <el-option v-for="item in pushStatusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="销售范围：" prop="categoryName">
            <el-select v-model="query.salesScope" placeholder="请选择">
              <el-option label="全平台" :value="1"></el-option>
              <el-option label="协议客户" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属分类：" prop="categoryName">
            <el-input
              v-model.trim="query.categoryName"
              placeholder="所属分类"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="品牌名称：" prop="brandName">
            <el-input
              v-model.trim="query.brandName"
              placeholder="品牌名称"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="可售区域：" prop="putOnStatus">
            <el-select v-model.trim="query.salesScopeId" placeholder="可售区域">
              <el-option
                v-for="item in areaArr"
                :key="item.salesScopeId"
                :label="item.salesScopeName"
                :value="item.salesScopeId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="商品类型：" prop="productType">
            <el-select v-model.trim="query.productType" placeholder="商品类型">
              <el-option v-for="item in productTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="currentIndex === 2 ? '提交时间：' : '审核时间：'" prop="time">
            <el-date-picker
              v-model="query.time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item v-if="editFlag === 'first'" label="店铺顺序：" prop="sortNumScreen">
            <el-select v-model.trim="query.sortNumScreen" placeholder="店铺顺序">
              <el-option v-for="item in sortNumList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="search-content">
          <!-- <el-button class="btn" type="primary" @click="handleReset">重置</el-button>
          <el-button class="btn search-btn" @click="handleSearch">查询</el-button> -->
          <eui-btn type="secondary" @click="handleReset">重置</eui-btn>
          <eui-btn type="weak" @click="handleSearch">查询</eui-btn>
        </div>
      </div>
      <div class="wrapper">
        <!-- tab切换 -->
        <div class="tab-content">
          <div
            v-for="(item, index) of tabArr"
            :key="index"
            class="tab-btn"
            :class="{ active: currentIndex === index }"
            @click="handleTab(index)"
          >
            <span style="padding-right: 8px">{{ item.tabName }}</span>
            <!-- <el-badge :value="item.badge" class="item"> </el-badge> -->
          </div>
        </div>
        <!-- 操作按钮 -->
        <div v-if="listQuery.exportStatus" class="handle-box">
          <eui-btn v-permission="['/product/skuManagement/skuPutawayBattch']" type="secondary" @click="handleManage">
            {{ listQuery.exportStatus == 101 ? '下架' : '上架' }}
          </eui-btn>
          <!-- <el-button @click="openAssociatedImagesDialog" v-if="listQuery.exportStatus === 102"
            >关联图片</el-button
          >-->
          <eui-btn v-permission="['/product/skuManagement/updateSalesAreaScope']" type="secondary" @click="setAreaRule">
            关联可售区域
          </eui-btn>
          <eui-btn
            v-permission="['/product/skuManagement/updateSkuPriceBatc']"
            type="secondary"
            @click="openAdjustPriceDialog"
          >
            多维度调价
          </eui-btn>
          <eui-btn
            v-permission="['/product/productExcel/importSkuTemplate']"
            type="secondary"
            @click="goToUrl('/batchEdit')"
          >
            批量导入修改
          </eui-btn>
          <eui-btn v-permission="['/skuManagement/updateSkuSalesScopeBattch']" type="secondary" @click="openSalesScope">
            批量修改销售范围
          </eui-btn>
          <eui-btn
            v-permission="['/product/productExcel/downProductList']"
            type="secondary"
            :loading="downloadLoading"
            @click="downloadData"
          >
            数据导出
          </eui-btn>
          <eui-btn
            v-if="listQuery.exportStatus === 102"
            v-permission="['/product/skuManagement/skuDeleteBattch']"
            type="secondary"
            @click="deleteProducts"
          >
            批量删除
          </eui-btn>
          <!-- v-if="relevanceImg" -->
          <eui-btn
            v-if="editFlag === 'second'"
            v-permission="['/auditManagement/unsubmitReleaseImagesUpdate']"
            type="secondary"
            @click="openAssociatedImagesDialog"
          >
            关联图片
          </eui-btn>
          <eui-btn v-if="currentIndex === 0" type="secondary" style="position: relative" @click="openExportDia">
            我要出口
            <el-tooltip
              style="position: absolute; right: -28px; top: 6px"
              class="item"
              effect="dark"
              placement="top-start"
            >
              <div slot="content">如果您在推送商品出口中遇到问题，请联系global.epec@sinopec.com</div>
              <div class="icon-question">?</div>
            </el-tooltip>
          </eui-btn>
        </div>
        <div v-else-if="editFlag === 'fifth'" class="handle-box">
          <eui-btn
            v-if="relevanceImg"
            v-permission="['/auditManagement/unsubmitReleaseImagesUpdate']"
            type="secondary"
            @click="openAssociatedImagesDialog"
          >
            关联图片
          </eui-btn>

          <!-- <el-button v-permission="['/product/productExcel/downProductList']">数据导出</el-button> -->
          <eui-btn
            v-permission="['/product/auditManagement/unsubmitReleaseDelete']"
            type="secondary"
            @click="batchDelHandle"
          >
            批量删除
          </eui-btn>
        </div>
        <div class="table-box">
          <!-- 上下架 -->
          <div v-if="editFlag === 'first' || editFlag === 'second'" key="20">
            <el-row>
              <div class="wrapper-set">
                <!-- 设置表格列展示字段 -->
                <div class="set-wrapper">
                  <div class="show-list">
                    <el-button type="primary" @click="showListHandle">列表项</el-button>
                  </div>
                  <div v-if="showListVisible" class="set-list">
                    <el-checkbox-group v-model="checkedTableColumns">
                      <el-checkbox v-for="column in tableColumns" :key="column.prop" :label="column.prop">
                        {{ column.label }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </div>
            </el-row>
            <!-- 上下架列表 -->
            <el-table
              ref="dataList"
              v-loading="tableLoading"
              :data="dataList"
              border
              @selection-change="handleSelectionChange"
              @cell-click="handleCellClick"
            >
              <!--                 :selectable="checkboxSelect" -->
              <el-table-column key="1" type="selection" width="36" fixed="left"></el-table-column>
              <el-table-column key="2" label="图片" width="60" fixed="left" align="center">
                <template slot-scope="scope">
                  <el-image
                    v-if="scope.row.defaultImage"
                    :src="scope.row.defaultImage"
                    :preview-src-list="[scope.row.defaultImage]"
                  >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column key="3" label="商品名称" min-width="310" fixed="left" align="center">
                <template slot-scope="{ row }">
                  <span class="table-handle-btn" @click="goToUrl('/productDetail', { skuId: row.skuId })">
                    {{ row.skuName }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column key="4" label="商品编号" min-width="160" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.skuCode }}</span>
                </template>
              </el-table-column>
              <el-table-column key="5" label="商品来源" min-width="90" align="center">
                <template slot-scope="scope">
                  <span>{{ formatSource(scope.row.systemSign) }}</span>
                </template>
              </el-table-column>
              <el-table-column key="6" label="进出口推送状态" min-width="120" align="center">
                <template slot-scope="scope">
                  <span>{{ getPushStatus(scope.row.pushStatus) }}</span>
                </template>
              </el-table-column>
              <el-table-column key="7" label="库存" min-width="110" align="center">
                <template slot-scope="{ row }">
                  <innerEditTableBlur
                    :key="row.skuId"
                    verify="skuStock"
                    :row="row"
                    :single.sync="row.skuStock"
                    :edit="'skuStockEdit'"
                    :placeholder="'请输入库存'"
                    @confirmEdit="skuStockConfirmEdit"
                  ></innerEditTableBlur>
                  <!-- <span>
                    {{ row.skuStock }}
                  </span>-->
                </template>
              </el-table-column>
              <el-table-column key="8" label="起订量" min-width="110" align="center">
                <template slot-scope="{ row }">
                  <innerEditTableBlur
                    :key="row.skuId"
                    verify="minOrderQuantityk"
                    :row="row"
                    :single.sync="row.minOrderQuantity"
                    :edit="'minOrderQuantitykEdit'"
                    :placeholder="'请输入起订量'"
                    @confirmEdit="minOrderQuantityConfirmEdit"
                  ></innerEditTableBlur>
                  <!-- <span>
                    {{ row.minOrderQuantity }}
                  </span>-->
                </template>
              </el-table-column>
              <el-table-column key="9" label="发货周期(天)" prop="deliverTime" min-width="90" align="center">
                <template slot-scope="{ row }">
                  <innerEditTableBlur
                    :key="row.skuId"
                    verify="deliverTime"
                    :row="row"
                    :single.sync="row.deliverTime"
                    :edit="'deliverTimeEdit'"
                    :placeholder="'请输入发货周期'"
                    @confirmEdit="deliverTimeConfirmEdit"
                  ></innerEditTableBlur>
                  <!-- <span>
                    {{ row.minOrderQuantity }}
                  </span>-->
                </template>
              </el-table-column>
              <el-table-column
                key="10"
                label="计量单位"
                prop="unitValue"
                min-width="70"
                align="center"
              ></el-table-column>
              <el-table-column key="11" label="市场价(元)" min-width="110" prop="price" align="center">
                <template slot-scope="{ row }">
                  <innerEditTableBlur
                    :key="row.skuId"
                    verify="price"
                    :row="row"
                    :single.sync="row.price"
                    :edit="'priceEdit'"
                    :placeholder="'请输入市场价'"
                    @confirmEdit="priceConfirmEdit"
                  ></innerEditTableBlur>
                  <!-- <span>
                    {{ row.minOrderQuantity }}
                  </span>-->
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="编辑时间"
                fixed="right"
                align="center"
                prop="updateTime"
              ></el-table-column> -->
              <el-table-column v-if="editFlag === 'second'" key="12" label="税率(%)" min-width="80" align="center">
                <template #default="{ row }">
                  <el-select v-model="row.taxRateId" placeholder="请选择税率" @change="taxRateChange($event, row)">
                    <el-option
                      v-for="taxItem in taxList"
                      :key="taxItem.taxRateId"
                      :label="taxItem.taxRate"
                      :value="taxItem.taxRateId"
                    >
                      <span>{{ taxItem.taxRate }}</span>
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column key="13" label="交货期" min-width="120" align="center">
                <template slot-scope="{ row }">
                  <!-- :popper-append-to-body="false" -->
                  <el-select v-model="row.deliveryType" placeholder="请选择" @change="deliveryTypeChange($event, row)">
                    <el-option label="现货" :value="1"></el-option>
                    <el-option label="期货" :value="2"></el-option>
                  </el-select>
                  <!-- <span>{{
                    scope.row.salesScope === 1 ? "全平台" : scope.row.salesScope === 2 ? "仅协议客户" : ""
                  }}</span>-->
                </template>
              </el-table-column>
              <el-table-column key="14" min-width="120" align="center">
                <template slot="header">
                  <span>销售范围</span>
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">
                      销售范围：是指您的商品对全平台客户的销售范围；
                      <br />
                      全平台：表示对平台所有客户销售；
                      <br />
                      仅协议客户：表示对您设置的平台协议客户，以协议价销售；
                    </div>
                    <div class="icon-question">?</div>
                  </el-tooltip>
                </template>
                <template slot-scope="{ row }">
                  <!-- :popper-append-to-body="false" -->
                  <el-select v-model="row.salesScope" placeholder="请选择" @change="salesScopeChange($event, row)">
                    <el-option label="全平台" :value="1"></el-option>
                    <el-option label="协议客户" :value="2"></el-option>
                  </el-select>
                  <!-- <span>{{
                    scope.row.salesScope === 1 ? "全平台" : scope.row.salesScope === 2 ? "仅协议客户" : ""
                  }}</span>-->
                </template>
              </el-table-column>
              <el-table-column key="15" min-width="130" align="center">
                <template slot="header">
                  <span>订单是否确认</span>
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">
                      选择”否”项表示不需要确认即生成有效订单（集成订单使用无效），默认订单都需要确认。
                    </div>
                    <div class="icon-question">?</div>
                  </el-tooltip>
                </template>
                <template slot-scope="{ row }">
                  <el-select v-model="row.isConfirm" placeholder="请选择" @change="isConfirmChange($event, row)">
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                v-for="column in bindTableColumns"
                :key="column.prop"
                key="16"
                :min-width="column.width"
                :label="column.label"
                align="center"
              >
                <template slot-scope="scope">
                  <template v-if="column.prop === 'salesScopeId'">
                    {{ scope.row.salesScopeId | areaFilter(areaArr) }}
                  </template>
                  <template>
                    <span>{{ scope.row[column.prop] }}</span>
                  </template>
                </template>
              </el-table-column>

              <el-table-column v-if="editFlag === 'second'" key="17" label="下架原因" align="center" min-width="120">
                <template slot-scope="{ row }">
                  <span v-if="row.enable === 1 && row.exportStatus === 102">人工下架</span>
                  <el-tooltip v-else hover class="error" effect="dark" placement="top-start">
                    <span slot="content">{{ row.denialReason }}</span>
                    <span>平台停用(原因)</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                key="18"
                min-width="90"
                :label="currentIndex === 2 ? '提交时间' : '审核时间'"
                align="center"
                prop="updateTime"
              ></el-table-column>
              <el-table-column
                v-if="editFlag === 'first'"
                key="19"
                min-width="90"
                label="店铺显示顺序"
                align="center"
                prop="sortNum"
              >
                <template slot-scope="scope">
                  <div v-if="currentSortIndex !== scope.$index">
                    <span class="overflow">{{ scope.row.sortNum ? scope.row.sortNum : '-' }}</span>
                    <el-button type="text" size="mini" @click="editSortNum(scope.$index, scope.row.skuId)">
                      <i class="title-icon el-icon-edit"></i>
                    </el-button>
                  </div>

                  <el-input
                    v-else
                    id="inputRef"
                    v-model.trim="scope.row.sortNum"
                    class="edit-input"
                    size="mini"
                    style="width: 100%"
                    @blur="sortNumConfirmEdit(scope.row.sortNum)"
                    @focus="sortNumFocus"
                    @input="scope.row.sortNum = scope.row.sortNum.replace(/[^0-9.]/g, '')"
                  />
                </template>
              </el-table-column>
              <el-table-column
                v-if="editFlag === 'first' || editFlag === 'second' || editFlag === 'fifth'"
                key="20"
                fixed="right"
                align="center"
              >
                <template slot="header">
                  <span>操作</span>
                  <el-tooltip
                    v-if="editFlag === 'second' || editFlag === 'fifth'"
                    class="item"
                    effect="dark"
                    placement="top-start"
                  >
                    <div slot="content">编辑商品的名称、图片，需要等待运营人员的审核</div>
                    <div class="icon-question">?</div>
                  </el-tooltip>
                </template>

                <template slot-scope="scope">
                  <span
                    v-if="
                      (editFlag === 'second' || editFlag === 'fifth') &&
                      (scope.row.systemSign === 0 || scope.row.systemSign === 1)
                    "
                    v-permission="['/auditManagement/productEditRelease']"
                    class="table-handle-btn"
                    type="text"
                    :class="{ 'edit-info': scope.row.auditStatus === 102 }"
                    @click="
                      goToUrl('/productEdit', {
                        skuId: scope.row.skuId,
                        auditStatus: scope.row.auditStatus,
                      })
                    "
                  >
                    编辑
                  </span>
                  <span
                    v-permission="['/auditManagement/productEditRelease']"
                    class="table-handle-btn"
                    type="text"
                    :class="{ 'edit-info': scope.row.auditStatus === 102 }"
                    @click="previewProduct(scope.row.skuId)"
                  >
                    预览
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 审核 -->
          <div v-if="editFlag === 'third' || editFlag === 'fourth' || editFlag === 'fifth'" key="21">
            <!-- 审核列表 -->
            <el-table
              ref="dataList"
              v-loading="tableLoading"
              :data="dataList"
              border
              @selection-change="handleSelectionChange"
              @cell-click="handleCellClick"
            >
              <el-table-column
                v-if="editFlag === 'fifth'"
                key="10"
                type="selection"
                width="36"
                fixed="left"
              ></el-table-column>
              <el-table-column key="0" label="图片" prop="productName" width="60" fixed="left" align="center">
                <template slot-scope="scope">
                  <el-image
                    v-if="scope.row.defaultImage"
                    class="default-img"
                    :src="scope.row.defaultImage"
                    :preview-src-list="[scope.row.defaultImage]"
                  >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column key="1" label="商品名称" min-width="320" fixed="left" align="center">
                <template slot-scope="{ row }">
                  <span
                    class="table-handle-btn"
                    @click="
                      goToUrl('/productDetail', {
                        productAuditId: row.productAuditId,
                      })
                    "
                  >
                    {{ row.skuName }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="商品来源" min-width="90" align="center">
                <template slot-scope="scope">
                  <span>{{ formatSource(scope.row.systemSign) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="商品编号" min-width="160" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.skuCode }}</span>
                </template>
              </el-table-column>
              <el-table-column key="2" label="品牌" prop="brandName" min-width="120" align="center"></el-table-column>
              <el-table-column key="6" label="税率" prop min-width="120" align="center">
                <template slot-scope="{ row }">
                  <span>
                    {{ `${row.taxRateValue}%` }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                key="7"
                label="计量单位"
                prop="unitValue"
                min-width="90"
                align="center"
              ></el-table-column>
              <el-table-column key="8" label="市场价(元)" prop="price" min-width="100" align="center"></el-table-column>
              <el-table-column v-if="editFlag === 'fifth'" key="20" label="审核拒绝" align="center">
                <template slot-scope="{ row }">
                  <el-tooltip hover class="error" effect="dark" placement="top-start">
                    <span slot="content">{{ row.approvalOpinion }}</span>
                    <span>审核拒绝</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                :label="currentIndex === 2 ? '提交时间' : '审核时间'"
                prop="updateTime"
              ></el-table-column>
              <el-table-column
                v-if="editFlag === 'second' || editFlag === 'fifth' || editFlag === 'third'"
                key="9"
                label="操作"
                fixed="right"
                align="center"
              >
                <template slot="header">
                  <span>操作</span>
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">编辑商品的名称、图片，需要等待运营人员的审核</div>
                    <div class="icon-question">?</div>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <span
                    v-if="editFlag === 'second' || editFlag === 'fifth'"
                    v-permission="['/auditManagement/productEditRelease']"
                    class="table-handle-btn"
                    type="text"
                    @click="
                      goToUrl('/productEdit', {
                        productAuditId: scope.row.productAuditId,
                      })
                    "
                  >
                    编辑
                  </span>
                  <span
                    v-if="editFlag === 'third' && scope.row.systemSign <= 1"
                    class="table-handle-btn"
                    type="text"
                    @click="handleWithdraw(scope.row.productAuditId)"
                  >
                    撤回
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-box">
            <el-pagination
              :page-sizes="[10, 20, 30]"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="listQuery.pageNum"
              :total="total"
              :page-size.sync="listQuery.pageSize"
              prev-text="上一页"
              next-text="下一页"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 区域调整弹窗 -->
    <area-dialog :area-form-visible.sync="areaFormVisible" :area-arr="areaArr" @areaHandle="areaHandle" />
    <!-- 多维度调价 -->
    <price-dialog
      :price-form-visible.sync="priceFormVisible"
      :price="adjustPrice"
      @handleAdjustPrice="handleAdjustPrice"
    />
    <!-- 批量修改销售范围 -->
    <sales-scope :sales-scope-visible.sync="salesScopeVisible" @salesScopeHandle="salesScopeHandle" />
    <!-- 维护图片弹窗 -->
    <associated-images
      ref="uploadImage"
      :associated-images-visible.sync="associatedImagesVisible"
      @getAllImageUrls="getAllImageUrls"
    />
    <!-- 出口弹窗 -->
    <export
      :export-dia-visible.sync="exportDiaVisible"
      :goods="pushGoods"
      :not-length="notPushGoodsLength"
      :all-length="multipleSelectionAll.length"
      @pushExportSuccess="pushExportSuccess"
    />

    <previewDialog :dialog-visible.sync="previewProductVisible" :sku-id="skuId"></previewDialog>
  </div>
</template>

<script>
import api from '../../api/product';
import authorityApi from '../../api/authority';
import AreaDialog from './createProducts/components/areaDialog.vue';
import PriceDialog from './createProducts/components/priceDialog.vue';
import SalesScope from './createProducts/components/salesScope.vue';
import utils from '../../utils/utils';
import InnerEditTableBlur from './components/innerEditTableBlur.vue';
import AssociatedImages from './components/associatedImages.vue';
import bus from '../../../../components/common/bus';
import Export from './components/exportDia.vue';

import previewDialog from './components/productDetail/previewDialog.vue';

export default {
  /* name: 'goodsMaintenance', */
  components: {
    AreaDialog,
    PriceDialog,
    SalesScope,
    InnerEditTableBlur,
    AssociatedImages,
    Export,
    previewDialog,
  },
  filters: {
    areaFilter(value, areaArr) {
      if (!value) return '';
      const { salesScopeName = '' } = areaArr.find((item) => item.salesScopeId === value) || {};
      return salesScopeName;
    },
  },
  props: {},
  data() {
    return {
      currentSortIndex: null,
      currentSkuId: null,
      exportDiaVisible: false,
      downloadLoading: false,
      systemSignList: [
        { value: null, label: '全部' },
        { value: 1, label: '平台新增' },
        { value: 2, label: '系统集成' },
        { value: 0, label: '保供平台' },
      ],
      tabArr: [
        { tabName: '已上架商品' },
        { tabName: '已下架商品' },
        { tabName: '审核中' },
        { tabName: '审核通过' },
        { tabName: '审核拒绝' },
      ],
      associatedImagesVisible: false,
      editFlag: 'first',
      idKey: 'skuId',
      salesScopeVisible: false,
      // 调整价格
      priceFormVisible: false,
      // 设置区域
      areaArr: [],
      areaFormVisible: false,
      // 列表搜索
      query: {},
      listQuery: {
        exportStatus: 101,
        pageNum: 1,
        pageSize: 10,
        systemSign: null,
      },
      cloneListQuery: {
        pageNum: 1,
        pageSize: 10,
        systemSign: null,
      },
      total: 0,
      allTotal: 0,
      tableLoading: false,
      dataList: [],
      // tab展示
      activeName: 'first',
      // 选中的列表数据
      multipleSelection: [],
      multipleSelectionAll: [],
      tableColumns: [
        /* { prop: "defaultImage", label: "图片", show: true, width: 80 },
        { prop: "skuName", label: "商品名称", show: true, width: 320 },
        { prop: "skuCode", label: "商品编号", show: true, width: 160 },
        { prop: "skuStock", label: "库存", show: true, width: 80 },
        { prop: "minOrderQuantity", label: "起订量", show: true, width: 110 },
        { prop: "isConfirm", label: "订单是否确认", show: true, width: 110 },
        { prop: "deliverTime", label: "发货周期(天)", show: true, width: 110 },
        { prop: "unitValue", label: "计量单位", show: true, width: 110 },
        { prop: "price", label: "市场价格", show: true, width: 110 },
        { prop: "salesScope", label: "销售范围", show: true, width: 120 }, */

        { prop: 'brandName', label: '品牌', show: false, width: 110 },
        { prop: 'categoryName', label: '所属分类', show: false, width: 110 },
        { prop: 'taxRateValue', label: '税率(%)', show: false, width: 90 },
        /* { prop: "salesScopeId", label: "可售区域", show: false, width: 90 }, */
      ],
      showListVisible: false,
      auditflag: false,
      adjustPrice: 0,
      currentIndex: 0,
      relevanceImg: true,
      productTypeList: [
        { id: 0, name: '普通商品' },
        { id: 1, name: '品牌商城商品' },
      ],
      // 国际站
      pushStatusList: [
        { id: 0, name: '推送中' },
        { id: 1, name: '已推送' },
        { id: 2, name: '推送失败' },
        { id: 3, name: '未推送' },
      ],
      sortNumList: [
        { id: '', name: '全部' },
        { id: 1, name: '有店铺顺序' },
      ],
      // 能推送的商品
      pushGoods: [],
      // 不能推送商品的长度
      notPushGoodsLength: 0,
      previewProductVisible: false,
      skuId: 0,
    };
  },
  computed: {
    bindTableColumns() {
      return this.tableColumns.filter((column) => column.show);
    },
    /* 这里使用了getter和setter，这样写的好处不用自己手动监听复选框的选中事件 */
    checkedTableColumns: {
      get() {
        // 返回选中的列名
        return this.bindTableColumns.map((column) => column.prop);
      },
      set(checked) {
        // 设置表格列的显示与隐藏
        this.tableColumns.forEach((column) => {
          // 如果选中，则设置列显示
          if (checked.includes(column.prop)) {
            column.show = true;
          } else {
            // 如果未选中，则设置列隐藏
            column.show = false;
          }
        });
      },
    },
  },
  created() {
    const { currentIndex } = this.$route.query;
    currentIndex ? this.handleTab(Number(currentIndex)) : this.handleTab(0);

    // this.getAllList(this.listQuery);
    this.getAreaArr();
    this.getTaxRateList();
  },
  /* activated() {
    this.getAllList(this.listQuery);
    this.getAuditList(this.listQuery);
  }, */
  mounted() {
    bus.$on('closeSelect', () => {
      /* console.log(this.$refs.mySelect);
      this.$refs.mySelect.handleClose && this.$refs.mySelect.handleClose(); */
      /* const selectEl = Array.from(document.body.querySelectorAll("body > .el-select-dropdown"));
      if (selectEl.length) {
        selectEl.forEach((item) => {
          item.style.display = "none";
        });
      } */
    });
  },
  destroyed() {
    bus.$off('closeSelect');
  },
  methods: {
    formatSource(source) {
      const { label = '' } = this.systemSignList.find((item) => item.value === source) || {};
      return label || '系统集成';
    },

    editSortNum(idx, skuId) {
      console.log(skuId);
      if (this.currentSkuId !== null) {
        return false;
      }
      this.currentSortIndex = idx;
      this.currentSkuId = skuId;

      this.$nextTick(() => {
        document.getElementById('inputRef').focus();
      });
      return true;
    },
    previewProduct(skuId) {
      this.skuId = skuId;
      this.previewProductVisible = true;
    },
    pushExportSuccess(val) {
      if (val === 'success') {
        this.handleSearch();
      }
      this.$refs.dataList.clearSelection(); // 清除全部的选中状态
    },
    getPushStatus(status) {
      const { name = '' } = this.pushStatusList.find((item) => item.id === status) || {};
      return name || '未推送';
    },
    openExportDia() {
      if (this.multipleSelectionAll.length === 0) {
        this.$message({
          message: '请选择需要处理的列表数据',
          type: 'warning',
        });
        return;
      }
      this.pushGoods = this.multipleSelectionAll.filter(
        (item) => item.pushStatus === 2 || item.pushStatus === 3 || item.pushStatus === undefined
      );
      console.log('选中的总条数:', this.multipleSelectionAll.length);
      console.log('可以推送的条数:', this.pushGoods.length);
      this.notPushGoodsLength = this.multipleSelectionAll.length - this.pushGoods.length;
      console.log('不可以推送的条数:', this.notPushGoodsLength);
      this.exportDiaVisible = true;
    },
    async getTaxRateList() {
      const res = await api.getTaxRateList();
      if (res.code === '200') {
        console.log(res.data, 'res.datares.data');
        res.data.forEach((item) => {
          item.taxRate += '';
        });
        this.taxList = res.data;
        console.log(this.taxList, 'this.taxList');
      }
    },
    reCreate() {
      if (process.env.NODE_ENV === 'production') {
        window.open('https://yyzx.epec.com/projectA/#/createProduct');
      } else {
        window.open('https://uat-yyzx.epec.com/projectA/#/createProduct');
      }
    },
    // tab切换
    async handleTab(index) {
      const res = await authorityApi.queryBackButton({
        authCode: '/goodsMaintenance',
      });
      this.$store.commit('button_directive', res.data);
      this.relevanceImg = res.data.some((item) => item.authCode == '/auditManagement/unsubmitReleaseImagesUpdate');
      this.currentIndex = index;
      this.multipleSelection = [];
      this.listQuery = { ...this.cloneListQuery };
      this.query = {};
      switch (index) {
        case 0:
          this.editFlag = 'first';
          this.idKey = 'skuId';
          delete this.listQuery.auditStatus;
          Object.assign(this.listQuery, { exportStatus: 101 });
          this.getAllList(this.listQuery);
          break;
        case 1:
          this.editFlag = 'second';
          this.idKey = 'skuId';
          delete this.listQuery.auditStatus;
          Object.assign(this.listQuery, { exportStatus: 102 });
          this.getAllList(this.listQuery);
          break;
        case 2:
          this.editFlag = 'third';
          this.idKey = 'productAuditId';
          delete this.listQuery.exportStatus;
          Object.assign(this.listQuery, { auditStatus: 102 });
          this.getAuditList(this.listQuery);
          break;
        case 3:
          this.editFlag = 'fourth';
          this.idKey = 'productAuditId';
          delete this.listQuery.exportStatus;
          Object.assign(this.listQuery, { auditStatus: 101 });
          this.getAuditList(this.listQuery);
          break;
        case 4:
          this.editFlag = 'fifth';
          this.idKey = 'productAuditId';
          delete this.listQuery.exportStatus;
          Object.assign(this.listQuery, { auditStatus: 104 });
          this.getAuditList(this.listQuery);
          break;
      }
      // 防止切换后刷新还在当前currentIndex tab
      window.location.hash = window.location.hash.split('?')[0];
      this.clearTable();
    },
    openAssociatedImagesDialog() {
      if (this.multipleSelectionAll.length === 0) {
        this.$message({
          message: '请选择需要处理的列表数据',
          type: 'warning',
        });
        return;
      }
      this.$refs.uploadImage.initData();
      this.associatedImagesVisible = true;
      this.$refs.uploadImage.initData();
    },
    // 维护图片提交
    async getAllImageUrls(val) {
      if (this.editFlag === 'fifth') {
        // 审核拒绝
        const productAuditIds = this.multipleSelectionAll.map((item) => item.productAuditId);
        const params = { productAuditIds };
        params.defaultImage = val.imageUrls[0] || val.imageUrlsExist[0];
        Object.assign(params, val);
        const { unsubmitReleaseImagesUpdate } = api;
        const res = await unsubmitReleaseImagesUpdate(params);
        if (+res.code === 200) {
          this.$message({
            message: '关联图片成功！',
            type: 'success',
          });
          Object.assign(this.listQuery, { auditStatus: 104 });
          this.getAuditList(this.listQuery);
          this.associatedImagesVisible = false;
          this.$refs.dataList.clearSelection(); // 清除全部的选中状态
        }
      } else {
        // 下架商品
        const productSkuIdList = this.multipleSelectionAll.map((item) => item.skuId);
        const params = { productSkuIdList };
        Object.assign(params, val);
        const imageUrls = [...params.imageUrls, ...params.imageUrlsExist];
        const detailImageUrls = [...params.detailImageUrls, ...params.detailImageUrlsExist];
        // params.detailImageUrls = params.imageUrls[0] || params.imageUrlsExist[0];
        params.imageUrls = imageUrls;
        params.detailImageUrls = detailImageUrls;
        console.log(params, '下架维护图片');
        const { modifyProductImages } = api;
        const res = await modifyProductImages(params);
        if (+res.code === 200) {
          this.$message({
            message: '关联图片成功！',
            type: 'success',
          });
          Object.assign(this.listQuery, { exportStatus: 102 });
          this.getAllList(this.listQuery);
          this.associatedImagesVisible = false;
          this.$refs.dataList.clearSelection(); // 清除全部的选中状态
        }
      }
    },
    // 停用商品不能选择了，不能上架
    /* checkboxSelect(row) {
      console.log(row);
      if (row.enable === 1) {
        return true;
      } else {
        return false;
      }
    }, */
    // 审核失败删除
    batchDelHandle() {
      if (this.multipleSelectionAll.length === 0) {
        this.$message({
          message: '请选择需要删除的数据',
          type: 'warning',
        });
        return;
      }
      this.$confirm('删除后不可恢复，确认要删除商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const productAuditIds = this.multipleSelectionAll.map((item) => item.productAuditId);
          console.log(productAuditIds);
          console.log(this.multipleSelectionAll);
          api
            .unsubmitReleaseDelete(productAuditIds)
            .then((res) => {
              if (res.code === '200') {
                this.clearTable();
                this.listQuery.pageNum = 1;
                this.getAuditList(this.listQuery);
                this.$message({
                  type: 'success',
                  message: '删除成功!',
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    // 修改订单是否确认
    async isConfirmChange(data, row) {
      console.log(data, row);
      const params = {
        skuId: row.skuId,
        isConfirm: Number(data),
      };
      const { updateSkuIsConfirm } = api;
      const res = await updateSkuIsConfirm(params);
      if (res.code !== '200') {
        this.getAllList(this.listQuery);
      }
    },
    // 修改税率
    async taxRateChange(data, row) {
      const params = {
        skuId: row.skuId,
      };
      const taxObj =
        this.taxList.find((item) => {
          return item.taxRateId === row.taxRateId;
        }) || {};
      taxObj.taxRateValue = Number(taxObj.taxRate);
      Object.assign(params, taxObj);
      const { taxRateEdite } = api;
      const res = await taxRateEdite(params);
      if (res.code !== '200') {
        this.getAllList(this.listQuery);
      }
    },
    // 可售范围修改
    async salesScopeChange(data, row) {
      const params = {
        skuId: row.skuId,
        salesScope: Number(data),
      };
      const { updateSkuSalesScope } = api;
      const res = await updateSkuSalesScope(params);
      if (res.code !== '200') {
        this.getAllList(this.listQuery);
      }
    },
    async deliveryTypeChange(data, row) {
      const params = {
        skuId: row.skuId,
        deliveryType: Number(data),
      };
      const { updateSkuDeliveryType } = api;
      const res = await updateSkuDeliveryType(params);
      if (res.code !== '200') {
        this.getAllList(this.listQuery);
      }
    },
    // 修改库存 ｜｜
    async skuStockConfirmEdit(data, row) {
      const params = {
        skuId: row.skuId,
        skuStock: Number(data),
      };
      const { updateSkuStock } = api;
      const res = await updateSkuStock(params);
      if (res.code !== '200') {
        this.getAllList(this.listQuery);
      }
    },
    // 修改起订量 ｜｜
    async minOrderQuantityConfirmEdit(data, row) {
      const params = {
        skuId: row.skuId,
        minOrderQuantity: Number(data),
      };
      const { updateOrderMinOrderQuantity } = api;
      const res = await updateOrderMinOrderQuantity(params);
      if (res.code !== '200') {
        this.getAllList(this.listQuery);
      }
    },
    // 修改发货周期 ｜｜
    async deliverTimeConfirmEdit(data, row) {
      const params = {
        skuId: row.skuId,
        deliverTime: data,
      };
      const { updateSkuDeliverTime } = api;
      const res = await updateSkuDeliverTime(params);
      if (res.code !== '200') {
        this.getAllList(this.listQuery);
      }
    },
    // 修改市场价格 ｜｜
    async priceConfirmEdit(data, row) {
      const params = {
        skuId: row.skuId,
        price: Number(data),
      };
      const { updateSkuPrice } = api;
      const res = await updateSkuPrice(params);
      if (res.code !== '200') {
        this.getAllList(this.listQuery);
      }
    },
    sortNumFocus() {
      console.log('focus');
    },
    async sortNumConfirmEdit(val) {
      this.tableLoading = true;
      console.log(val);
      const numberRegPositive = /^[1-9]\d*$/; // 正整数不包含0
      if (val !== '' && !numberRegPositive.test(val)) {
        this.$message.error('请输入正整数');
        this.tableLoading = false;
        this.$nextTick(() => {
          document.getElementById('inputRef').focus();
        });
        return false;
      }
      if (val > 9999) {
        this.$message.error('请输入小于等于9999的正整数');
        this.tableLoading = false;
        val = 9999;
        this.$nextTick(() => {
          document.getElementById('inputRef').focus();
        });
        return false;
      }
      console.log(this.currentSkuId);
      const params = {
        skuId: this.currentSkuId,
        sortNum: val,
      };
      const res = await api.updateSkuSortNum(params);
      if (res.code === '200') {
        this.tableLoading = false;
        this.currentSortIndex = null;
        this.currentSkuId = null;
      } else {
        this.getAllList(this.listQuery);
      }
      return true;
    },
    //
    // 数据导入
    async downloadData() {
      const params = {};
      Object.assign(params, this.listQuery);
      params.pageSize = this.total;
      console.log(params);
      this.downloadLoading = true;
      const res = await api.downProductList(params);
      this.downloadLoading = false;
      if (res.size !== 0) {
        utils.downFile(res);
      }
    },
    // 跳转链接
    goToUrl(url, row = {}) {
      // , auditStatus = ""
      const { skuId = '', productAuditId = '' } = row;
      if (skuId) {
        this.$router.push({
          path: url,
          query: { skuId, currentIndex: this.currentIndex },
        });
        return;
      }
      if (this.listQuery.auditStatus === 104 && productAuditId) {
        this.$router.push({
          path: url,
          query: {
            productAuditId,
            auditStatus: 104,
            currentIndex: this.currentIndex,
          },
        });
        return;
      }
      if (productAuditId) {
        this.$router.push({
          path: url,
          query: { productAuditId, currentIndex: this.currentIndex },
        });
        return;
      }
      this.$router.push({ path: url });
      /* this.$router.push({
        name: "productEdit",
        params: { skuImportId },
      }); */
    },
    handleWithdraw(productAuditId) {
      // 集成商品不支持撤回
      this.$confirm(
        '<strong>您要撤回该商品的申请吗？不可恢复！</strong><br/><span>撤回后可以商品发布列表页面进行再次编辑</span>',
        '撤回',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(async () => {
          const result = await api.modifyRevokeSubmitReview({ productAuditId });
          if (result.code === '200') {
            this.$message({
              type: 'success',
              message: '撤回成功!',
            });
            this.getAuditList(this.listQuery);
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消撤回',
          });
        });
    },
    // 点击是否展示列表项设置
    showListHandle() {
      this.showListVisible = !this.showListVisible;
    },
    clearTable() {
      this.multipleSelection = []; // 清空当前列表页选择的数据项
      this.multipleSelectionAll = []; // 清空已选择的数据项
      this.$refs.dataList.clearSelection(); // 清除全部的选中状态
    },
    handleCellClick(row, column) {
      if (column.property === 'skuName') {
        this.$router.push({
          path: 'productDetail',
          query: { productId: row.productId },
        });
      }
    },

    // 删除下架商品
    deleteProducts() {
      if (this.multipleSelectionAll.length === 0) {
        this.$message({
          message: '请选择需要处理的列表数据',
          type: 'warning',
        });
        return;
      }
      this.$confirm('确定删除所选?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const skuIds = this.multipleSelectionAll.map((item) => item.skuId);
          // 需要接口
          api.skuDeleteBattch(skuIds).then((res) => {
            if (res.code === '200') {
              this.getAllList(this.listQuery);
              this.clearTable();
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },
    // 批量修改销售范围
    openSalesScope() {
      if (this.multipleSelectionAll.length === 0) {
        this.$message({
          message: '请选择需要处理的列表数据',
          type: 'warning',
        });
        return;
      }
      this.salesScopeVisible = true;
    },
    // 批量修改销售范围
    async salesScopeHandle(salesScope) {
      const skuIds = this.multipleSelectionAll.map((item) => item.skuId);
      const params = {
        salesScope,
        skuIds,
      };
      const { updateSkuSalesScopeBattch } = api;
      const res = await updateSkuSalesScopeBattch(params);
      if (+res.code === 200) {
        this.$message({
          message: '销售范围修改成功！',
          type: 'success',
        });
        this.getAllList(this.listQuery);
        this.clearTable();
        this.salesScopeVisible = false;
      }
    },
    // 多维度调价
    openAdjustPriceDialog() {
      // updateSkuPriceBatch
      if (this.multipleSelectionAll.length === 0) {
        this.$message({
          message: '请选择需要处理的列表数据',
          type: 'warning',
        });
        return;
      }
      this.priceFormVisible = true;
      const priceArr = this.multipleSelectionAll.map((item) => item.price);
      this.adjustPrice = Math.min(...priceArr);
    },
    async handleAdjustPrice(val) {
      const params = { ...val };
      const skus = this.multipleSelectionAll.map((item) => ({
        skuId: item.skuId,
      }));
      params.skus = skus;
      const { updateSkuPriceBatch } = api;
      const res = await updateSkuPriceBatch(params);
      if (res.code === '200') {
        this.priceFormVisible = false;
        this.$message({
          message: '多维度调价成功！',
          type: 'success',
        });
        this.getAllList(this.listQuery);
        this.clearTable();
      }
    },
    // 获取全部接口
    async getAllList(params) {
      this.dataList = [];
      try {
        this.tableLoading = true;
        const { querySkuByPage } = api;
        const res = await querySkuByPage(params);
        this.tableLoading = false;
        if (res.code === '200') {
          const { data } = res;
          this.dataList = [...data.records];
          this.setSelectRow();
          this.total = data.total;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 获取审核的接口
    async getAuditList(params) {
      this.dataList = [];
      try {
        const { queryReleaseProductByPage } = api;
        this.tableLoading = true;
        const res = await queryReleaseProductByPage(params);
        this.tableLoading = false;
        if (res.code === '200') {
          const { data } = res;
          this.dataList = [...data.records];
          this.setSelectRow();
          this.total = data.total;
        }
      } catch (err) {
        console.log(err);
      }
    },

    // 获取区域列表
    async getAreaArr() {
      const { querySalesScopeList } = api;
      await querySalesScopeList()
        .then((res) => {
          if (res.code === '200') {
            this.areaArr = [...res.data];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 关联可售区域
    setAreaRule() {
      if (this.multipleSelectionAll.length === 0) {
        this.$message({
          message: '请选择需处理的列表的数据',
          type: 'warning',
        });
        return;
      }
      this.areaFormVisible = true;
    },
    // 关联可售区域确定
    async areaHandle(salesScopeId) {
      const skuIds = this.multipleSelectionAll.map((item) => item.skuId);
      await api
        .updateSalesAreaScope({ skuIds, salesScopeId })
        .then((res) => {
          if (res.code === '200') {
            delete this.cloneListQuery.auditStatus;
            this.$refs.dataList.clearSelection(); // 清除全部的选中状态
            this.cloneListQuery.exportStatus = this.listQuery.exportStatus;
            this.getAllList(this.cloneListQuery);
            this.clearTable();
            this.$message({
              message: '可售区域设置成功',
              type: 'success',
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.clearTable();
          this.areaFormVisible = false;
        });
    },
    //
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      if (this.listQuery.exportStatus) {
        this.getAllList(this.listQuery);
      } else {
        this.getAuditList(this.listQuery);
      }
    },
    // 改变条数
    handleSizeChange(val) {
      // 改变每页显示条数的时候调用一次
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      if (this.listQuery.exportStatus) {
        this.getAllList(this.listQuery);
      } else {
        this.getAuditList(this.listQuery);
      }
      this.changePageCoreRecordData();
    },
    // 列表搜索
    handleSearch() {
      console.log(this.query);
      this.listQuery.pageNum = 1;
      this.listQuery.startTime = this.query.time ? this.query.time[0] : '';
      this.listQuery.endTime = this.query.time ? this.query.time[1] : '';
      Object.assign(this.listQuery, this.query);
      if (this.listQuery.exportStatus) {
        this.getAllList(this.listQuery);
      } else {
        this.getAuditList(this.listQuery);
      }
      this.clearTable();
    },
    // 列表搜索重置
    handleReset() {
      if (this.listQuery.exportStatus) {
        delete this.cloneListQuery.auditStatus;
        this.cloneListQuery.exportStatus = this.listQuery.exportStatus;
        this.getAllList(this.cloneListQuery);
      } else {
        delete this.cloneListQuery.exportStatus;
        this.cloneListQuery.auditStatus = this.listQuery.auditStatus;
        this.getAuditList(this.cloneListQuery);
      }
      this.query = {};
      this.listQuery = { ...this.cloneListQuery };
      this.clearTable();
    },
    handleEdit(val) {
      this.$router.push({ path: '/productEdit', query: { productId: val } });
    },
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
      this.getAllSelectionData();
    },

    // 商品上架-下架
    handleManage() {
      if (this.multipleSelectionAll.length === 0) {
        this.$message({
          message: '请选择需要处理的列表数据',
          type: 'warning',
        });
        return;
      }
      const message =
        this.listQuery.exportStatus == 101
          ? '下架商品请在“已下架商品”标签页查看,确定下架吗?'
          : '上架商品请在“已上架商品”标签页查看,确定上架吗?';
      const skuIds = this.multipleSelectionAll.map((item) => item.skuId);
      console.log(skuIds);
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (this.listQuery.exportStatus == 101) {
            this.HandleSoldOut(skuIds);
          } else if (this.listQuery.exportStatus == 102) {
            this.handlePutaway(skuIds);
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },

    // 商品下架
    HandleSoldOut(skuIds) {
      api
        .skuSoldOutBattch(skuIds)
        .then((res) => {
          if (res.code === '200') {
            this.listQuery.pageNum = 1;
            this.$refs.dataList.clearSelection(); // 清除全部的选中状态
            this.getAllList(this.listQuery);
            this.clearTable();
            this.$message({
              type: 'success',
              message: '商品下架成功!',
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 商品上架
    handlePutaway(skuIds) {
      api
        .skuPutawayBattch(skuIds)
        .then((res) => {
          if (res.code === '200') {
            this.listQuery.pageNum = 1;
            this.getAllList(this.listQuery);
            this.clearTable();
            this.$message({
              type: 'success',
              message: '商品上架成功!',
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // -- 跨页多选方法 --
    // 设置选中的方法
    setSelectRow() {
      if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
        return;
      }
      // 标识当前行的唯一键的名称
      const { idKey } = this;
      const selectAllIds = [];
      this.multipleSelectionAll.forEach((row) => {
        selectAllIds.push(row[idKey]);
      });
      this.$refs.dataList.clearSelection();
      this.$nextTick(() => {
        for (let i = 0; i < this.dataList.length; i++) {
          if (selectAllIds.indexOf(this.dataList[i][idKey]) >= 0) {
            this.$refs.dataList.toggleRowSelection(this.dataList[i], true);
          }
        }
      });
    },
    // 记忆选择核心方法
    changePageCoreRecordData() {
      // 标识当前行的唯一键的名称
      const { idKey } = this;
      const that = this;
      // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
      if (this.multipleSelectionAll.length <= 0) {
        this.multipleSelectionAll = this.multipleSelection;
        return;
      }
      // 总选择里面的key集合
      const selectAllIds = [];
      this.multipleSelectionAll.forEach((row) => {
        selectAllIds.push(row[idKey]);
      });
      const selectIds = [];

      // 获取当前页选中的id
      this.multipleSelection.forEach((row) => {
        selectIds.push(row[idKey]);
        // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
        if (selectAllIds.indexOf(row[idKey]) < 0) {
          that.multipleSelectionAll.push(row);
        }
      });
      const noSelectIds = [];
      // 得到当前页没有选中的id
      this.dataList.forEach((row) => {
        if (selectIds.indexOf(row[idKey]) < 0) {
          noSelectIds.push(row[idKey]);
        }
      });
      noSelectIds.forEach((id) => {
        if (selectAllIds.indexOf(id) >= 0) {
          for (let i = 0; i < that.multipleSelectionAll.length; i++) {
            if (that.multipleSelectionAll[i][idKey] == id) {
              // 如果总选择中有未被选中的，那么就删除这条
              that.multipleSelectionAll.splice(i, 1);
              break;
            }
          }
        }
      });
    },
    // 得到选中的所有数据
    getAllSelectionData() {
      this.changePageCoreRecordData();
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-question {
  height: 18px;
  width: 18px;
  line-height: 18px;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #c5c5c5;
  color: #c5c5c5;
  display: inline-block;
  margin-left: 10px;
  &:hover {
    color: #fff;
    background-color: #c5c5c5;
  }
}
::v-deep .el-date-editor .el-range-separator {
  width: auto;
}
.create-product {
  /* select 下拉不固定的解决方案 加css el-select标签 加:popper-append-to-body="false"  */
  /* ::v-deep .el-table .cell {
    overflow: visible;
    .el-select-dropdown {
      top: 32px !important;
      left: 0 !important;
    }
  } */
  /* 修改这个属性 列表select就OK了 但是不能滚动了 */
  /* ::v-deep .el-table--scrollable-x .el-table__body-wrapper {
    overflow: visible;
  } */

  ::v-deep .el-table__header .cell {
    .icon-question {
      @extend .icon-question;
      /* height: 18px;
      width: 18px;
      line-height: 18px;
      text-align: center;
      border-radius: 50%;
      border: 1px solid #c5c5c5;
      color: #c5c5c5;
      display: inline-block;
      margin-left: 10px;
      &:hover {
        color: #fff;
        background-color: #c5c5c5;
      } */
    }
  }
  ::v-deep .el-table__row .cell {
    font-size: 12px;
    white-space: normal;
    padding-left: 6px;
    padding-right: 6px;
    .el-button {
      font-size: 12px;
    }
    .el-input__inner {
      padding: 0 6px;
    }
    .edit-info {
      color: #c0c4cc;
    }
  }
  ::v-deep .el-table--small td,
  ::v-deep .el-table--small th {
    padding: 6px 0;
  }
  ::v-deep .el-table--small .el-table-column--selection {
    .cell {
      padding-left: 10px;
      padding-right: 10px;
      .el-checkbox__inner {
        border-radius: 0;
      }
    }
  }
  ::v-deep .el-image {
    width: 48px;
    height: 48px;
    display: block;
    font-size: 0;
    ::v-deep img {
      display: block;
      width: 100%;
      width: 100%;
    }
  }
  .wrapper {
    margin-top: 20px;
    background: #fff;
  }
  .search-box {
    background: #fff;
    padding: 10px;
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 10px;
      margin-right: 20px;
    }
    .search-content {
      text-align: center;
      display: flex;
      justify-content: center;
      .btn {
        height: 30px;
        line-height: 30px;
        padding: 0;
        min-width: 80px;
        text-align: center;
        background: #fff;
        border: 1px solid #c5c5c5;
        color: #333;
        &:hover {
          color: #2587ff;
          border-color: #bedbff;
          background-color: #e8efff;
        }
      }
      .search-btn {
        border: 1px solid #2587ff;
        background: #fff;
        color: #2587ff;
        margin-left: 30px;
        &:hover {
          background: #e8efff;
        }
      }
    }
  }

  .handle-box {
    white-space: nowrap;
    background: #fff;
    margin-top: 20px;
    padding: 0 20px;
    min-height: 32px;
    .delete {
      color: #c5c5c5;
    }
  }

  .wran-msg {
    background: #e8efff;
    padding: 15px 10px;
    color: #333333;
    display: flex;
    font-size: 14px;
    margin-bottom: 20px;
    .bold {
      display: inline-block;
      font-weight: bold;
      text-align: right;
      color: #f0250f;
      flex-shrink: 0;
      flex-grow: 0;
      // flex-basis: 82px;
    }
    .re-reeact {
      color: #2587ff;
      cursor: pointer;
    }
  }

  .table-box {
    padding: 0 20px 20px 20px;
    ::v-deep .el-table {
      margin-top: 10px;
    }
  }
  .pagination-box {
    text-align: right;
    margin-top: 20px;
    ::v-deep .el-pagination {
      button {
        height: 30px;
        color: #999;
      }
      .el-select {
        .el-input__inner {
          border-radius: 0;
          height: 30px;
        }
      }
      .el-input__inner {
        border-radius: 0;
        height: 30px;
        color: #999;
      }
      .el-select-dropdown__item,
      .el-pagination__jump,
      .el-pagination__total {
        color: #999;
      }
      .el-pager {
        li {
          border-radius: 0;
          border: 1px solid #d9d9d9;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 40px;
          height: 30px;
          color: #999;
          &:first-child {
            margin-left: 0;
          }
          &.active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }

  .tab-content {
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 20px;
    .tab-btn {
      position: relative;
      height: 40px;
      line-height: 40px;
      flex: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      color: #606266;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      font-weight: 500;
      padding: 0 20px;
      font-size: 14px;
      border-left: 1px solid #d9d9d9;
      border-bottom: 1px solid #d9d9d9;
      &:last-child {
        border-right: 0;
      }
      &:first-child {
        border-left: 0;
      }
      &.active {
        background: #f4f7ff;
        color: #0064c8;
        height: 40px;
        line-height: 40px;
        &::after {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          content: '';
          width: 100%;
          height: 2px;
          background: #0064c8;
        }
      }
    }

    /* .border {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      border-top: 1px solid #d9d9d9;
      z-index: 1;
    } */
  }

  .error {
    color: red;
    cursor: pointer;
  }

  .search-form {
    ::v-deep .el-input {
      width: 192px;
    }
  }

  .amplification {
    margin-left: 10px;
  }

  .set-wrapper {
    position: relative;
    .show-list {
      text-align: right;
      position: relative;
      ::v-deep .el-button {
        min-width: 80px;
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
        color: #fff;
        position: absolute;
        top: -30px;
        right: 0;
      }
    }
    .el-icon-setting {
      position: absolute;
      right: 0;
      top: -22px;
    }
    .set-list {
      position: absolute;
      width: 112px;
      z-index: 100;
      top: 10px;
      right: 0;
      background: #fff;
      border: 1px solid #ddd;
      padding: 10px;
      box-sizing: border-box;
      .el-checkbox {
        width: 100%;
        margin-right: 0;
      }
    }
  }
}
</style>
<style>
.el-tooltip__popper {
  max-width: 320px;
}
</style>
